import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as ConfigurationReducer } from './configurationRedux'
import { reducer as UserReducer } from './userRedux'
import { reducer as AuthReducer } from './authRedux';
import { reducer as LayoutReducer } from './layoutRedux'
import { reducer as LinkConfigReducer } from './linkConfigRedux'
import { reducer as AccountDataReducer } from './accountDataRedux'
import { reducer as ClientReducer } from './clientRedux'
import { reducer as ProductReducer } from './productRedux'
import { reducer as TicketReducer } from './ticketRedux'
import { reducer as ErrorReducer } from './errorRedux'

const rootReducer = (history) => combineReducers({
    configuration: ConfigurationReducer,
    user: UserReducer,
    auth: AuthReducer,
    layout: LayoutReducer,
    linkConfig: LinkConfigReducer,
    accountData: AccountDataReducer,
    client: ClientReducer,
    product: ProductReducer,
    tickets: TicketReducer,
    error: ErrorReducer,
    router: connectRouter(history)
});

export default rootReducer;
